t = require('views/internal/teacup-with-helpers')('list_add')

module.exports = t.renderable ({ tooManyTotalLists, tooManyOpenLists, isFirstList, distinctLists }) ->
  tooManyLists = tooManyTotalLists || tooManyOpenLists

  t.form ->
    t.span '.placeholder', { class: t.classify('js-open-add-list': !tooManyLists) }, ->
      if tooManyTotalLists
        t.format 'you-have-too-many-lists'
      else if tooManyOpenLists
        t.format 'you-have-too-many-open-lists'
      else
        if distinctLists
          t.icon 'add'
          if isFirstList
            t.format 'add-a-list'
          else
            t.format 'add-another-list'
        else
          t.format 'add-a-list-ellipsis'

    if !tooManyLists
      placeholder = t.l 'add-a-list-ellipsis'
      saveText = t.l 'save'
      if distinctLists
        placeholder = t.l 'enter-list-title-ellipsis'
        saveText = t.l 'add-list'

      t.input '.list-name-input', {
        type: 'text',
        name: 'name',
        placeholder: placeholder,
        autocomplete: 'off',
        dir: 'auto',
        maxLength: 512
      }

      t.div '.list-add-controls.u-clearfix', ->
        t.input '.primary.mod-list-add-button.js-save-edit', { type: 'submit', value: saveText }
        t.a '.icon-lg.icon-close.dark-hover.js-cancel-edit', { href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/list_add.coffee